import { render } from "./identifiant.vue?vue&type=template&id=2f1440bd&scoped=true"
import script from "./identifiant.vue?vue&type=script&lang=js"
export * from "./identifiant.vue?vue&type=script&lang=js"

import "./identifiant.vue?vue&type=style&index=0&id=2f1440bd&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1440bd"]])

export default __exports__